import React from 'react';
import { Box } from '@mui/material';
import ConsultaIaChat from '../components/Consultas/ConsultaIaChat';
import type { ModuloConsultaIa } from '../types/consultasIa';

const TITLES: Record<ModuloConsultaIa, string> = {
    ventas: 'Consulta inteligente — Ventas',
    compras: 'Consulta inteligente — Compras',
    inventario: 'Consulta inteligente — Inventario',
    tesoreria: 'Consulta inteligente — Tesorería',
};

interface ConsultaIaModuloPageProps {
    modulo: ModuloConsultaIa;
}

const ConsultaIaModuloPage: React.FC<ConsultaIaModuloPageProps> = ({ modulo }) => (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh', p: { xs: 2, sm: 3 } }}>
        <ConsultaIaChat key={modulo} titulo={TITLES[modulo]} modulo={modulo} />
    </Box>
);

export default ConsultaIaModuloPage;
